import React from 'react';
// Components
import Icon from '../components/icon';
// Assets
import facebook from '../../images/sprite/facebook.svg';
import twitter from '../../images/sprite/twitter.svg';
// Misc
import {
  FACEBOOK_URL,
  TWITTER_URL
} from '../libs/get-social';

const ShareBar = () => (
  <div className="share-bar">
    <p className="share-bar__text">Share it</p>
    <hr className="share-bar__hr" />
    <a
      target="blank"
      rel="noopener noreferrer"
      href={FACEBOOK_URL}
    >
      <Icon className="icon--facebook" glyph={facebook} />
    </a>
    <a
      target="blank"
      rel="noopener noreferrer"
      href={TWITTER_URL}
    >
      <Icon className="icon--twitter" glyph={twitter} />
    </a>
  </div>
);

export default ShareBar;



/** WEBPACK FOOTER **
 ** ./src/js/components/share-bar.js
 **/